import React from 'react';
import { Layout } from '#hocs/layout';
import {
  Doubts,
  ExperienceImprove,
  OtherSections,
  ProductHighlight,
  Remembers,
} from '#components/organisms';

const StatisticsView = () => {
  const section = 'statistics';

  return (
    <Layout section={section}>
      <ProductHighlight section={section} />
      <Remembers
        header="Crecimiento"
        section={section}
        title="Nuestros datos no se equivocan"
      />
      <Doubts />
      <ExperienceImprove />
      <OtherSections />
    </Layout>
  );
};

export default StatisticsView;
